import { EVENT } from '../constants'
import { GA4Event, GA4GeneralProps } from '../GA4Event'

export interface GA4ComponentViewItem {
  resourceId?: string | null
  componentName?: string | null
  componentClass?: string | null
  componentRank?: number | null
  panelName?: string | null
  panelClass?: string | null
  panelRank?: number | null
}

// Internal GA4 e-commerce item structure — mapped automatically from GA4ComponentViewItem.
// Do not use this interface directly; use GA4ComponentViewItem instead.
interface GA4ComponentViewEcommerceItem {
  item_id: string | null // resourceId
  item_name: string | null // componentName
  item_brand: string | null // componentClass
  index: number | null // componentRank
  item_category: string | null // panelName
  item_category2: string | null // panelClass
  item_category3: number | null // panelRank
}

interface Properties extends GA4GeneralProps {
  viewedComponents?: GA4ComponentViewItem[] | null
}

export class GA4ComponentViewEvent extends GA4Event {
  ga4_viewed_components?: GA4ComponentViewEcommerceItem[] | null

  constructor({ viewedComponents = null, ...generalProps }: Properties) {
    super({ event: EVENT.COMPONENT_VIEW, ...generalProps })

    this.ga4_viewed_components = viewedComponents
      ? viewedComponents.map((item) => ({
          item_id: item.resourceId ?? null,
          item_name: item.componentName ?? null,
          item_brand: item.componentClass ?? null,
          index: item.componentRank ?? null,
          item_category: item.panelName ?? null,
          item_category2: item.panelClass ?? null,
          item_category3: item.panelRank ?? null,
        }))
      : null
  }
}
